"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "bh": 15,
    "aav": 209,
    "afa": 298,
    "alg": 415,
    "alv": 430,
    "apa": 505,
    "aqa": 531,
    "aql": 536,
    "art": 558,
    "ath": 596,
    "auf": 620,
    "aus": 633,
    "awd": 655,
    "azc": 702,
    "bad": 714,
    "bai": 719,
    "bat": 727,
    "ber": 826,
    "bnt": 1054,
    "btk": 1193,
    "cai": 1366,
    "cau": 1377,
    "cba": 1383,
    "ccn": 1413,
    "ccs": 1418,
    "cdc": 1420,
    "cdd": 1421,
    "cel": 1439,
    "cmc": 1529,
    "cpe": 1584,
    "cpf": 1585,
    "cpp": 1590,
    "crp": 1611,
    "csu": 1641,
    "cus": 1677,
    "day": 1721,
    "dmn": 1867,
    "dra": 1913,
    "egx": 2024,
    "esx": 2110,
    "euq": 2123,
    "fiu": 2165,
    "fox": 2187,
    "gem": 2313,
    "gme": 2399,
    "gmq": 2405,
    "gmw": 2409,
    "grk": 2475,
    "him": 2626,
    "hmx": 2667,
    "hok": 2689,
    "hyx": 2760,
    "iir": 2814,
    "ijo": 2819,
    "inc": 2858,
    "ine": 2859,
    "ira": 2878,
    "iro": 2884,
    "itc": 2904,
    "jpx": 3043,
    "kar": 3090,
    "kdo": 3160,
    "khi": 3256,
    "kro": 3511,
    "map": 4085,
    "mkh": 4328,
    "mno": 4409,
    "mun": 4581,
    "myn": 4681,
    "nah": 4726,
    "nai": 4727,
    "ngf": 4848,
    "nic": 4894,
    "nub": 5131,
    "omq": 5301,
    "omv": 5305,
    "oto": 5370,
    "paa": 5394,
    "phi": 5499,
    "plf": 5554,
    "poz": 5639,
    "pqe": 5655,
    "pqw": 5657,
    "pra": 5658,
    "qwe": 5793,
    "roa": 5920,
    "sai": 5984,
    "sal": 5987,
    "sdv": 6065,
    "sem": 6080,
    "sgn": 6110,
    "sio": 6158,
    "sit": 6163,
    "sla": 6211,
    "smi": 6240,
    "son": 6291,
    "sqj": 6325,
    "ssa": 6359,
    "syd": 6474,
    "tai": 6506,
    "tbq": 6538,
    "trk": 6863,
    "tup": 6942,
    "tut": 6945,
    "tuw": 6948,
    "urj": 7122,
    "wak": 7262,
    "wen": 7311,
    "xgn": 7563,
    "xnd": 7653,
    "ypk": 7975,
    "zhx": 8104,
    "zle": 8129,
    "zls": 8134,
    "zlw": 8135,
    "znd": 8163
};
//# sourceMappingURL=collection.json.js.map